import * as React from 'react';
import { useId } from '../../internal/hooks';
import { useControllableState } from '../../internal/hooks/useControllableState';
import { DIALOG_NAME } from './constants';
import { DialogProvider } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogRoot = props => {
  const {
    __scopeDialog,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const triggerRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const [open = false, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /*#__PURE__*/_jsx(DialogProvider, {
    scope: __scopeDialog,
    triggerRef: triggerRef,
    contentRef: contentRef,
    contentId: useId(undefined),
    titleId: useId(undefined),
    descriptionId: useId(undefined),
    open: open,
    onOpenChange: setOpen,
    onOpenToggle: React.useCallback(() => setOpen(prevOpen => !prevOpen), [setOpen]),
    modal: modal,
    children: children
  });
};
DialogRoot.displayName = DIALOG_NAME;